import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Card} from 'material-ui/Card';
import compose from 'recompose/compose';
import inflection from 'inflection';
import ViewTitle from 'admin-on-rest/lib/mui/layout/ViewTitle';
import Title from 'admin-on-rest/lib/mui/layout/Title';
import PageDescription from '../components/PageDescription';
import {crudCreate as crudCreateAction} from 'admin-on-rest/lib/actions/dataActions';
import DefaultActions from 'admin-on-rest/lib/mui/detail/CreateActions';
import translate from 'admin-on-rest/lib/i18n/translate';
import withPermissionsFilteredChildren from 'admin-on-rest/lib/auth/withPermissionsFilteredChildren';

/**
 * Create page component (AOR override)
 *
 */
class CreateWithType extends Component {
    getBasePath() {
        const {location} = this.props;
        return location.pathname
            .split('/')
            .slice(0, -1)
            .join('/');
    }

    getBasePathUpOne() {
        const {location} = this.props;
        return location.pathname
            .split('/')
            .slice(0, -2)
            .join('/');
    }

    defaultRedirectRoute() {
        const {hasShow, hasEdit} = this.props;
        if (hasEdit) return 'edit';
        if (hasShow) return 'show';
        return 'list';
    }

    save = (record, redirect) => {
        const basePath = this.getBasePath();
        const path = (redirect === 'list') ? basePath : basePath + '/' + record.type;
        this.props.crudCreate(
            this.props.resource,
            record,
            path,
            redirect
        );
    };

    render() {
        const {
            actions = <DefaultActions/>,
            children,
            desc,
            isLoading,
            resource,
            title,
            translate,
            hasList,
        } = this.props;

        if (!children) return null;
        const basePath = this.getBasePath();

        const resourceName = translate(`resources.${resource}.name`, {
            smart_count: 1,
            _: inflection.humanize(inflection.singularize(resource)),
        });
        const defaultTitle = translate('aor.page.create', {
            name: `${resourceName}`,
        });
        const titleElement = (
            <Title title={title} defaultTitle={defaultTitle}/>
        );
        const descriptionElement = desc ? (
            <PageDescription desc={desc}/>
        ) : (
            ''
        );

        return (
            <div className="create-page">
                <Card style={{opacity: isLoading ? 0.8 : 1}}>
                    {actions &&
                    React.cloneElement(actions, {
                        basePath,
                        resource,
                        hasList,
                    })}
                    <ViewTitle title={titleElement}/>
                    {descriptionElement}
                    {React.cloneElement(children, {
                        save: this.save,
                        resource,
                        basePath,
                        record: {},
                        translate,
                        redirect:
                            typeof children.props.redirect === 'undefined'
                                ? this.defaultRedirectRoute()
                                : children.props.redirect,
                    })}
                </Card>
            </div>
        );
    }
}

CreateWithType.propTypes = {
    actions: PropTypes.element,
    children: PropTypes.element,
    crudCreate: PropTypes.func.isRequired,
    desc: PropTypes.any,
    isLoading: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    title: PropTypes.any,
    translate: PropTypes.func.isRequired,
    hasList: PropTypes.bool,
};

CreateWithType.defaultProps = {
    data: {},
};

function mapStateToProps(state, props) {
    return {
        isLoading: state.admin.loading > 0
    };
}

const enhance = compose(
    connect(mapStateToProps, {crudCreate: crudCreateAction}),
    translate,
    withPermissionsFilteredChildren
);

export default enhance(CreateWithType);



// WEBPACK FOOTER //
// ./src/Fuse/admin/CreateWithType.js